import { getSchemeColor } from '@griply/utils';
import { DefaultTheme } from 'styled-components';

import { ColorScheme } from './theme/color-schemes';

// polished throws on unparseable values — an unknown registry key must degrade, not crash.
const renderableColorPattern = /^(#[0-9a-f]{3,8}|rgba?\(|hsla?\()/i;

export const schemeColor = <T extends string | null | undefined>(
  color: T,
  theme: DefaultTheme,
): T => {
  const resolved = getSchemeColor(
    color,
    theme.colorScheme === ColorScheme.Dark,
  );
  if (!resolved || renderableColorPattern.test(resolved)) {
    return resolved;
  }
  return theme.palette.grey[400] as T;
};
